import React from "react";

const Product = () => {
  return <h2>Product Page</h2>;
};

export default Product;
